import FormComponents from "components/forms/FormComponents";
import { Icon, Modal } from "enums";
import manager from "managers/app";
import { ExtractionsModalProps } from "modals/content/extractions/types";
import ModalContent from "modals/content/ModalContent";
import ModalFooter from "modals/footer/ModalFooter";
import ModalHeader from "modals/header/ModalHeader";
import { Component } from "react";
import { connect } from "react-redux";
import { AppState } from "types/app";
import "./ExtractionsModal.css";

const mapStateToProps = (state:AppState):ExtractionsModalProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		extractions: state.modal[Modal.EXTRACTIONS],
	};
};

class ExtractionsModal extends Component<ExtractionsModalProps.Component> {
	render():JSX.Element{
		return (
			<div id={Modal.EXTRACTIONS} className="modal-wrapper">
				<ModalHeader text="Materia Extraction" icon={Icon.EXTRACTION} />
				<ModalContent>
					<div>
						{/* Placeheolder Modal - Currently this is unusued as extraction can only be true or undefined */}
					</div>
				</ModalContent>
				<ModalFooter>
					<FormComponents.Button text="Close" onClick={manager.modal.close} translate={true} />
				</ModalFooter>
			</div>
		);
	}
}
export default connect(mapStateToProps)(ExtractionsModal);
